<template>
    <div class="pulse-loading-bar" :class="props.rootClass" role="presentation">
        <div class="pulse-loading-bar__track">
            <div class="pulse-loading-bar__fill" />
        </div>
    </div>
</template>

<script setup lang="ts">
/**
 * Indeterminate progress strip: a gold gradient pulse slides across a muted track.
 *
 * Used under Processing status titles on loading scrims. Does not convey a numeric percent;
 * pair with copy or a parent `role="status"` when announcing loading state.
 *
 * **Nuxt registration:** `components/shared/PulseLoadingBar.vue` → `SharedPulseLoadingBar`.
 */
const props = withDefaults(
    defineProps<{
        /** Extra classes merged onto the outer wrapper (margins, width constraints). */
        rootClass?: string | string[] | Record<string, boolean>
    }>(),
    {
        rootClass: undefined,
    }
)
</script>

<style scoped>
.pulse-loading-bar {
    margin: 1rem 0 0.25rem;
}

.pulse-loading-bar__track {
    position: relative;
    height: 3px;
    border-radius: 2px;
    background: rgba(15, 23, 43, 0.08);
    overflow: hidden;
}

.pulse-loading-bar__fill {
    position: absolute;
    top: 0;
    left: -40%;
    width: 40%;
    height: 100%;
    background: linear-gradient(
        90deg,
        rgba(201, 169, 110, 0) 0%,
        #c9a96e 50%,
        rgba(201, 169, 110, 0) 100%
    );
    animation: pulse-loading-bar-slide 2.4s cubic-bezier(0.55, 0.05, 0.35, 0.95) infinite;
}

@keyframes pulse-loading-bar-slide {
    0% {
        left: -40%;
    }

    100% {
        left: 100%;
    }
}

@media (prefers-reduced-motion: reduce) {
    .pulse-loading-bar__fill {
        animation: none;
        left: 30%;
    }
}
</style>
